import { useFormik } from "formik";
import i18n, { t } from "i18next";
import moment from "moment";
import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { RadioButton } from "primereact/radiobutton";
import { classNames } from "primereact/utils";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button as AntButton } from "antd";

import JordanianBuyer from "../../../../../components/JordanianBuyer";
import PageLayoutWithSidebar from "../../../../../components/PageLayoutWithSidebar";
import { configFun } from "../../../../../config";
import * as utils from "../../../../../helpers/utils";
import {
  agencyValidations,
  deputyValidations,
  getFormErrorMessage,
  guardianValidationsNew,
  isFormValid,
} from "../../../../../helpers/utils";
import {
  showError,
  updateLoading,
  updateSellingFormObject,
} from "../../../../../redux/actions";
import { getBuyerApproval, getUserInfo } from "../../../../../services";
import Agency from "../../../CommonViews/OnBehalf/Agency";
import CompanyBuyer from "../../../CommonViews/OnBehalf/CompanyBuyer";
import Deputy from "../../../CommonViews/OnBehalf/Deputy";
import ForeignBuyer from "../../../CommonViews/OnBehalf/ForeignBuyer";
import Guardian from "../../../CommonViews/OnBehalf/GuardianNew";
import InputsComponent from "../../../../../components/Common/Form/InputComp";
import InputsRow from "../../../../../components/Common/Form/InputsRow";

const DebtorInfo = (props) => {
  const { demo } = props;

  const sponsorTypeOptions = [
    {
      label: t("mortgageServices.self"),
      value: "self",
    },
    {
      label: t("mortgageServices.other"),
      value: "other",
    },
  ];

  const [submitForm, setSubmitForm] = useState(false);
  const [buyerItem, setBuyerItem] = useState({});
  const [showForm, setShowForm] = useState(false);
  const [hideAdd, setHideAdd] = useState(false);
  const dispatch = useDispatch();
  const sellingFormDetails = useSelector((state) => state.sellingFormDetails);
  const deptors = sellingFormDetails["deptorsDetails"] || [];
  const donation = sellingFormDetails["donation"];
  const [sponsorType, setSponsorType] = useState(
    sellingFormDetails["sponsorType"] || "self"
  );

  const setBuyers = (arr) => {
    const myObj = { ...sellingFormDetails, deptorsDetails: arr, sponsorType };
    dispatch(updateSellingFormObject(myObj));
  };

  const isDuplicated = (id) => {
    if (buyerItem.nationalId) {
      return false;
    }
    return deptors.find((ele) => ele.nationalId === id);
  };

  const isSponsor = (id) => {
    return (
      sellingFormDetails.selectedShares?.findIndex(
        (sponsor) => +sponsor.partyId === +id
      ) > -1
    );
  };

  const isCreditor = (id) => {
    return (
      sellingFormDetails.creditorDetails?.findIndex(
        (creditor) => +creditor.nationalId === +id
      ) > -1
    );
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      nationalId: "",
      deptorCardNo: "",
      deptorName: "",
      deptorArabicName: "",
      deptorEnglishName: "",
      adjective: 1,
      exemption: "",
      deptorAge: "",
      deptorType: "jordanian",
      hasIdCard: true,
      deptorBirthDate: "",
      personStatus: 0,
      exemptStatus: "notExempt",

      personalNumber: "",
      passportNumber: "",
      passportExp: "",
      passport: "",
      name: "",
      nationality: "",
      motherName: "",
      birthDate: "",
      investApprovalNum: "",
      investApproval: "",

      isSoldier: false,
      soldireAttachment: "",

      court: {},
      isJordanianAgent: true,
      isInternalAgency: true,
      isJordanianClient: true,
      agencyNumber: "",
      attachAgency: "",
      agencyDate: "",
      agencyPlace: "",
      agentName: "",
      agencyClientName: "",
      agencyType: "",
      agencyStatus: "",
      agentNationalId: "",
      agentPersonalNumber: "",

      clientNationalId: "",
      clientPersonalNumber: "",
      isJordanianGuardian: true,
      isJordanianMinor: true,
      guardianNationalId: "",
      guardianPersonalNumber: "",
      guardianshipNumber: "",
      salesAuthorizationNumber: "",
      minorNationalId: "",
      minorPersonalNumber: "",

      guardianName: "",
      guardianshipDate: "",
      guardianshipPlace: "",
      guardianCardNo: "",
      guardianshipAttachment: "",
      salesAuthorizationDate: "",
      salesAuthorizationPlace: "",
      mortgageAuthorizationAttachment: "",
      minorName: "",

      isJordanianDeputy: true,

      entityNum: "",
      entityName: "",
      deputyNum: "",
      deputyDate: "",
      phoneNum: "",
      deputyAttach: "",
      deputyInfo: {},
      deputyNationalId: "",
      deputyPersonalNumber: "",
      deputyCardNo: "",
      entityCode: "",
      investmentApproval: "",
      neighborhood: "",
      street: "",
      address: "",
      phone: "",
    },
    validate: (data) => {
      let errors = {};
      if (data.deptorType === "jordanian") {
        if (!data.nationalId) {
          errors.nationalId = t("errors.required");
        } else if (!/^\d{10}$/g.test(data.nationalId)) {
          errors.nationalId = t("errors.nationalId10Digits");
        } else if (isDuplicated(data.nationalId)) {
          errors.nationalId = t("errors.alreadyExists");
        } else if (isSponsor(data.nationalId) && sponsorType === "other") {
          errors.nationalId = t("errors.existsInSponsors");
        } else if (isCreditor(data.nationalId)) {
          errors.nationalId = t("errors.existsInCreditor");
        }
        // existsInCreditor
        // existsInDebtor

        if (data.isSoldier) {
          if (!data.soldireAttachment) {
            errors.soldireAttachment = t("errors.required");
          }
          if (!data.deptorArabicName) {
            errors.deptorArabicName = t("errors.required");
          }
        } else {
          if (data.hasIdCard) {
            if (!data.deptorCardNo) {
              errors.deptorCardNo = t("errors.required");
            }
          } else if (!data.deptorBirthDate) {
            errors.deptorBirthDate = t("errors.required");
          }
        }

        if (data.exemption) {
          if (!data.appDate) {
            errors.exemption = t("errors.searachForExemption");
          }
        }
      } else if (data.deptorType === "foreign") {
        // if (!data.investApproval) {
        //   errors.investApproval = t("errors.required");
        // } else if (data.investApproval !== t("common.agree")) {
        //   errors.investApproval = "";
        // }
        if (!data.nationalId) {
          errors.nationalId = t("errors.required");
        } else if (isSponsor(data.nationalId) && sponsorType === "other") {
          errors.nationalId = t("errors.existsInSponsors");
        } else if (isCreditor(data.nationalId)) {
          errors.nationalId = t("errors.existsInCreditor");
        }
        if (!data.passport) {
          errors.passport = t("errors.required");
        }
      } else if (data.deptorType === "company") {
        if (!data.nationalId) {
          errors.nationalId = t("errors.required");
        } else if (isDuplicated(data.nationalId)) {
          errors.nationalId = t("errors.alreadyExists");
        }

        if (!data.buyerArabicName) {
          errors.nationalId = t("errors.required");
        }
      }

      // Add required validation for new fields
      if (!data.neighborhood) {
        errors.neighborhood = t("errors.required");
      }
      if (!data.street) {
        errors.street = t("errors.required");
      }
      if (!data.address) {
        errors.address = t("errors.required");
      }
      if (!data.phone) {
        errors.phone = t("errors.required");
      }
      if (data.entityCode === "5") {
        // if (
        //   !data.investmentApproval ||
        //   data.investmentApproval !== t("common.agree")
        // ) {
        //   errors.investmentApproval = t("errors.envestmentApproval");
        // }
      }
      if (data.adjective === 1) {
        return errors;
      } else if (data.adjective === 2) {
        // agent
        errors = { ...errors, ...agencyValidations(data) };
      } else if (data.adjective === 3 || data.adjective === 5) {
        // guardian
        errors = {
          ...errors,
          ...guardianValidationsNew(data, { isMortgage: true }),
        };
      } else if (data.adjective === 4) {
        // deputy
        errors = { ...errors, ...deputyValidations(data) };
      }

      return errors;
    },
    onSubmit: (data) => {
      saveChanges(data);
    },
  });

  useEffect(() => {
    if (!demo) {
      // if (deptors.length < 1 && sponsorType === "other") {
      if (deptors.length < 1) {
        props.onDisableNext(true);
        setHideAdd(false);
      } else {
        props.onDisableNext(false);
        setHideAdd(false);
      }
    }
  }, [deptors, sponsorType]);

  const getBuyerAdjective = (rowData) => {
    const adjective = rowData.adjective || 1;
    return configFun().userTypesNew.find((ele) => ele.value === adjective);
    // if (
    //   rowData.deptorType === "company" ||
    //   rowData.deptorAge >= 18 ||
    //   rowData.buyerAge >= 18 ||
    //   rowData.isSoldier
    // ) {
    //   const adjective = rowData.adjective || 1;
    //   return configFun().userTypes.find((ele) => ele.value === adjective);
    // } else {
    //   return configFun().userTypes.find((ele) => ele.value === 3);
    // }
  };

  const deleteItem = (rowData) => {
    const newBuyers = deptors.filter((object) => {
      return object.nationalId !== rowData.nationalId;
    });
    setBuyers(newBuyers);
  };

  const allowedSearch = () => {
    return (
      formik.values.nationalId &&
      (formik.values.deptorCardNo ||
        moment().diff(formik.values.deptorBirthDate, "years") < 18)
    );
  };

  const editItem = (rowData) => {
    formik.setValues(rowData);
    if (!demo) {
      props.onHidePageActions(true);
    }
    setBuyerItem(rowData);
    setShowForm(true);
  };

  const getFields = () => {
    return [
      {
        label: t("realtySelling.nationalIdOrPersonal"),
        key: "nationalId",
      },
      {
        label: t("realtySelling.personalCardIDOrPassport"),
        key: "deptorCardNo",
        body: (rowData) => {
          return rowData.deptorCardNo || "-";
        },
      },
      {
        label: t("mortgageServices.deptorName"),
        key: "deptorArabicName",
        body: (rowData) => {
          return rowData.deptorType === "company"
            ? rowData.buyerArabicName
            : rowData.deptorArabicName;
        },
      },
      {
        label: t("حالة الإعفاء"),
        key: "exemptStatus",
        body: (rowData) => {
          return t(`mortgageServices.${rowData.exemptStatus}`);
        },
      },
      {
        label: t("mortgageServices.deptorAdjective"),
        key: "adjective",
        body: (rowData) => {
          const adjective = getBuyerAdjective(rowData);
          rowData["adjective"] = adjective.value;
          return <span className="text-danger">{adjective?.label}</span>;
        },
      },
      {
        label: "",
        key: "actions",
        body: (rowData) => {
          if (demo) {
            return (
              <AntButton
                onClick={() => editItem(rowData)}
                className="action-btn text-xs mx-1 text-sm main-button buttonWidth bg-success"
              >
                {t("common.adjectiveChange")}
              </AntButton>
            );
          }
          return rowData.nationalId === buyerItem.nationalId ? (
            <i className="pi pi-arrow-right bg-main-color text-white p-1 rounded text-sm" />
          ) : (
            <div className="d-flex">
              <Button
                icon="pi pi-trash text-danger text-sm"
                disabled={rowData.nationalId === buyerItem.nationalId || demo}
                onClick={() => deleteItem(rowData)}
                className="p-button-rounded  bg-transparent outline-none"
                aria-label="Bookmark"
              />
            </div>
          );
        },
      },
    ];
  };

  const getComponentAdjective = () => {
    switch (formik.values.adjective) {
      case 2:
        return (
          <Agency
            item={buyerItem}
            submitClick={submitForm}
            onUpdate={(value) => setBuyerItem(value)}
            editItem={buyerItem}
            formik={formik}
            buyer
            valuesNamesMapper={{
              agentInfo: "agentInfo",
              clientInfo: "clientInfo",
              agentNationalId: "agentNationalId",
              agentPersonalNumber: "agentPersonalNumber",
              firstCardNo: "agentCardNo",
              secondCardNo: "clientCardNo",
            }}
            demo={demo}
            newRepresentationsBy
          />
        );
      case 3:
      case 5:
        return (
          <Guardian
            item={buyerItem}
            submitClick={submitForm}
            onUpdate={(value) => setBuyerItem(value)}
            formik={formik}
            mortgage={true}
            valuesNamesMapper={{
              objectHolderData: "guardianNationalId",
              agentInfo: "agentInfo",
              clientInfo: "clientInfo",
              agentNationalId: "guardianNationalId",
              agentPersonalNumber: "agentPersonalNumber",
              firstCardNo: "guardianCardNo",
              secondCardNo: "minorCardNo",
              guardianCardNo: "guardianCardNo",
              guardianNationalId: "guardianNationalId",
              guardianPersonalNumber: "guardianPersonalNumber",
              guardianshipAttachment: "guardianshipAttachment",
              salesAuthorizationAttachment: "mortgageAuthorizationAttachment",
              guardianInfo: "guardianInfo",
            }}
            demo={demo}
            buyer
          />
        );
      case 4:
        return (
          <Deputy
            valuesNamesMapper={{
              agentInfo: "deputyInfo",
              agentNationalId: "deputyNationalId",
              agentPersonalNumber: "deputyPersonalNumber",
              firstCardNo: "deputyCardNo",
              secondCardNo: "clientCardNo",
            }}
            formik={formik}
            demo={demo}
          />
        );
      default:
        return null;
    }
  };

  const handleAddBuyer = () => {
    setShowForm(true);
    props.onHidePageActions(true);
  };

  const saveChanges = (data) => {
    if (data.nationalId === buyerItem.nationalId) {
      const myBuyers = [...deptors];
      const idx = myBuyers.findIndex(
        (buyer) => buyer.nationalId === data.nationalId
      );
      myBuyers[idx] = data;
      setBuyers(deptors);
    } else {
      setBuyers([...deptors, data]);
    }
    setShowForm(false);
    setBuyerItem({});
    props.onHidePageActions(false);
    formik.resetForm();
  };
  const cancelEdit = () => {
    setShowForm(false);
    setBuyerItem({});
    if (!demo) {
      props.onHidePageActions(false);
    }
    formik.resetForm();
  };

  useEffect(() => {
    if (!demo) {
      if (submitForm) {
        formik.submitForm();
        setTimeout(() => {
          setSubmitForm(false);
        }, 1000);
      }
    }
  }, []);

  useEffect(() => {
    // if (sponsorType === "self" && !demo) {
    if (!demo) {
      props.onHidePageActions(false);
    }
  }, [sponsorType]);

  const getBuyerDetails = () => {
    if (
      !formik.values.nationalId ||
      (!formik.values.deptorCardNo && !formik.values.deptorBirthDate) ||
      moment().diff(formik.values.deptorBirthDate, "years") >= 18
    ) {
      return;
    }
    const isExists = deptors.find(
      (ele) => formik.values.nationalId === ele.nationalId
    );
    if (isExists) {
      dispatch(showError(t("errors.buyerexists")));
      
      return;
    }
    dispatch(updateLoading(true));
    utils.resetFetchedAgencyInfo(formik);
    getUserInfo(
      formik.values.nationalId,
      formik.values.deptorCardNo,
      false,
      formik.values.deptorBirthDate
    ).then((response) => {
      const { data } = response;
      formik.setFieldValue("personStatus", utils.getPersonStatus(data.deatH_C));
      if (data.deatH_C === 0) {
        const { arName, enName } = utils.getUserName(data);
        formik.setFieldValue("deptorArabicName", arName);
        formik.setFieldValue("deptorEnglishName", enName);
        formik.setFieldValue(
          "deptorAge",
          moment().diff(moment(data.birthdt), "years")
        );
        if (moment().diff(moment(data.birthdt), "years") < 18) {
          formik.setFieldValue("adjective", 3);
        }
      } else {
        dispatch(
          showError(t("errors.buyerMustBeAlive", { buyer: t("errors.buyer") }))
        );
        
      }
    });
  };

  const getBuyerApprovalData = () => {
    if (formik.values.exemption && formik.values.nationalId) {
      getBuyerApproval(formik.values.exemption, formik.values.nationalId).then(
        (resp) => {
          if (resp.data) {
            formik.setFieldValue(
              "appDate",
              moment(resp.data.appDate).format("DD/MM/YYYY")
            );
          } else {
            formik.setFieldValue("appDate", t("errors.noData"));
            formik.setFieldValue("exemption", "");
          }
        }
      );
    }
  };

  const resetForm = async (value) => {
    await formik.resetForm();
    formik.setFieldValue("deptorType", value);
  };

  const resetHasIdCardFields = () => {
    formik.setFieldValue("deptorCardNo", "");
    formik.setFieldValue("deptorArabicName", "");
    formik.setFieldValue("deptorBirthDate", "");
  };

  return (
    <React.Fragment>
      <PageLayoutWithSidebar className="mt-4">
        <div className="d-flex justify-content-between">
          <p className="fm-kufi-bold text-sm">
            {t("mortgageServices.deptorInfo")}
          </p>
        </div>

        <div className="col-12 col-md-6 col-lg-4 mb-4 form-inputs">
          <label className="block text-xs fm-kufi-regular text-form-label">
            {t("mortgageServices.sponsorType")}{" "}
            <span className="text-danger">*</span>
          </label>
          <div>
            <Dropdown
              className="mt-2 w-100"
              value={sponsorType}
              onChange={(e) => {
                setSponsorType(e.target.value);
                setBuyers([]);
              }}
              options={sponsorTypeOptions}
              name="sponsorType"
              optionLabel="label"
              optionValue="value"
              disabled={demo}
            />
          </div>
        </div>
        <React.Fragment>
          <>
            <DataTable
              emptyMessage={t("common.noResultsFound")}
              className="realty-table fm-kufi-regular"
              tableClassName="w-100"
              value={deptors}
              responsiveLayout="scroll"
            >
              {getFields().map((item) => (
                <Column
                  key={item.key}
                  field={item.key}
                  header={item.label}
                  body={item.body ? item.body : null}
                />
              ))}
            </DataTable>
          </>
          {!showForm && !hideAdd && !demo && (
            // (sponsorType !== "self" || deptors.length < 1) && (
            <Button
              className="add-buyer fm-kufi-regular text-sm offset-3"
              label={t("mortgageServices.addNewDeptor")}
              icon="pi pi-plus"
              iconPos="left"
              onClick={handleAddBuyer}
            />
          )}

          {(showForm || (buyerItem && buyerItem.nationalId)) && (
            <PageLayoutWithSidebar className="mt-4">
              <form onSubmit={formik.handleSubmit}>
                <div className="row my-3">
                  <div className="col-sm-3 col-12">
                    <RadioButton
                      value="jordanian"
                      checked={formik.values.deptorType === "jordanian"}
                      name="deptorType"
                      disabled={demo}
                      onChange={(e) => {
                        formik.setFieldValue("deptorType", e.value);
                        resetForm(e.value);
                      }}
                    />
                    <label className="block text-sm fm-kufi-regular text-form-label">
                      {t("realtySelling.jordanian")}
                    </label>
                  </div>
                  <div className="col-sm-3 col-12">
                    <RadioButton
                      value="foreign"
                      checked={formik.values.deptorType === "foreign"}
                      name="deptorType"
                      disabled={demo}
                      onChange={(e) => {
                        formik.setFieldValue("deptorType", e.value);
                        resetForm(e.value);
                      }}
                    />
                    <label className="block text-sm fm-kufi-regular text-form-label">
                      {t("realtySelling.forigen")}
                    </label>
                  </div>
                  <div className="col-sm-3 col-12">
                    <RadioButton
                      value="company"
                      checked={formik.values.deptorType === "company"}
                      name="deptorType"
                      onChange={(e) => {
                        formik.setFieldValue("deptorType", e.value);
                        resetForm(e.value);
                      }}
                      disabled={formik.values.deptorType === "company" || demo}
                    />
                    <label className="block text-sm fm-kufi-regular text-form-label">
                      {t("realtySelling.company")}
                    </label>
                  </div>
                </div>

                <div className="row">
                  {formik.values.deptorType === "jordanian" && (
                    <JordanianBuyer
                      formik={formik}
                      demo={props.demo}
                      sellers={[]}
                      buyers={deptors}
                      donation={donation}
                      hasIdtTitle={t("mortgageServices.hasIdCardDeptor")}
                      buyerName={t("mortgageServices.deptorName")}
                      withoutExemption
                      keyMapper={{
                        buyerCardNo: "deptorCardNo",
                        buyerArabicName: "deptorArabicName",
                        buyerBirthDate: "deptorBirthDate",
                        nationalId: "nationalId",
                        buyerEnglishName: "deptorEnglishName",
                        card_expiry: "card_expiry",
                        card_no: "card_no",
                        card_issuer: "card_issuer",
                        buyerAge: "deptorAge",
                        adjective: "adjective",
                        exemption: "exemption",
                        appDate: "appDate",
                        hasIdCard: "hasIdCard",
                        isSoldier: "isSoldier",
                      }}
                    />
                  )}
                  {formik.values.deptorType === "foreign" && (
                    <ForeignBuyer
                      formik={formik}
                      demo={demo}
                      noInvestApproval
                      // noPassport
                      keyMapper={{
                        personalNumber: "nationalId",
                        passportNumber: "deptorCardNo",
                        name: "deptorArabicName",
                        nationality: "nationality",
                        motherName: "motherName",
                        birthDate: "birthDate",
                        investApprovalNum: "investApprovalNum",
                        investApproval: "investApproval",
                      }}
                    />
                  )}

                  {formik.values.deptorType === "company" && (
                    <CompanyBuyer
                      formik={formik}
                      demo={demo}
                      noInvestApproval
                    />
                  )}

                  {/* <div className="row my-3">
                    <div className="col-sm-3 col-12">
                      <RadioButton
                        value="exempt"
                        checked={formik.values.exemptStatus === "exempt"}
                        name="exemptStatus"
                        disabled={demo}
                        onChange={(e) => {
                          formik.setFieldValue("exemptStatus", e.value);
                        }}
                      />
                      <label className="block text-sm fm-kufi-regular text-form-label">
                        {t("mortgageServices.exempt")}
                      </label>
                    </div>
                    <div className="col-sm-3 col-12">
                      <RadioButton
                        value="notExempt"
                        checked={formik.values.exemptStatus === "notExempt"}
                        name="exemptStatus"
                        disabled={demo}
                        onChange={(e) => {
                          formik.setFieldValue("exemptStatus", e.value);
                        }}
                      />
                      <label className="block text-sm fm-kufi-regular text-form-label">
                        {t("mortgageServices.notExempt")}
                      </label>
                    </div>
                  </div> */}
                  {/* 
                  add here text input using InputsComponent component
                  with required validation
                  i want them for 
                  اسم الحي و اسم الشارع و العنوان و رقم الهاتف
                  add them to translation files too
                  */}
                  <InputsRow>
                    <InputsComponent
                      title={t("mortgageServices.neighborhood")}
                      required
                      name="neighborhood"
                      value={formik.values.neighborhood}
                      onChange={formik.handleChange}
                      formik={formik}
                      disabled={demo}
                    />
                    <InputsComponent
                      title={t("mortgageServices.street")}
                      required
                      name="street"
                      value={formik.values.street}
                      onChange={formik.handleChange}
                      formik={formik}
                      disabled={demo}
                    />
                    <InputsComponent
                      title={t("mortgageServices.address")}
                      required
                      name="address"
                      value={formik.values.address}
                      onChange={formik.handleChange}
                      formik={formik}
                      disabled={demo}
                    />
                    <InputsComponent
                      title={t("mortgageServices.phone")}
                      required
                      name="phone"
                      value={formik.values.phone}
                      onChange={formik.handleChange}
                      formik={formik}
                      disabled={demo}
                    />
                  </InputsRow>
                  {sponsorType === "other" && (
                    <div className="col-lg-3 col-sm-6 mb-4 form-inputs">
                      <label className="block text-xs fm-kufi-regular text-form-label">
                        {t("mortgageServices.debtorAdjective")}{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <div>
                        <Dropdown
                          className="mt-2 w-100"
                          value={formik.values.adjective}
                          onChange={(e) => {
                            utils.resetAdjective(formik);
                            formik.handleChange(e);
                          }}
                          // options={
                          //   formik.values.deptorType !== "company"
                          //     ? configFun().userTypes.slice(0, 3)
                          //     : configFun().userTypes
                          // }
                          options={utils.getUserTypesByBuyerType(
                            configFun().userTypesNew,
                            formik.values.deptorType === "company",
                            formik.values.isSoldier,
                            formik.values.deptorAge || formik.values.buyerAge
                          )}
                          optionLabel="label"
                          optionValue="value"
                          name="adjective"
                          disabled={
                            formik.values.deptorType === "company" || demo
                          }
                        />
                        {getFormErrorMessage(formik, "adjective")}
                      </div>
                    </div>
                  )}
                </div>

                {getComponentAdjective()}

                <div className="row gap-3 justify-content-center my-4 submit-action">
                  <Button
                    type="submit"
                    label={t("common.save")}
                    onClick={() => setSubmitForm(true)}
                    style={{ minWidth: "max-content" }}
                    // disabled={!formik.isValid}
                    disabled={
                      !formik.isValid ||
                      (formik.values.deptorType === "company"
                        ? !formik.values.buyerArabicName
                        : !formik.values.deptorArabicName) ||
                      demo
                    }
                    className="action-btn col-lg-2 col-sm-4 d-block h-fit submit-btn py-2 text-xs fm-kufi-regular text-sm"
                  />
                  <Button
                    onClick={cancelEdit}
                    className="action-btn col-lg-2 d-block col-sm-4 h-fit py-2 text-xs back-btn mx-2 fm-kufi-regular text-sm"
                  >
                    {t("common.cancel")}
                  </Button>
                </div>
              </form>
            </PageLayoutWithSidebar>
          )}
        </React.Fragment>
        {/* {sponsorType === "other" && (
        )} */}
      </PageLayoutWithSidebar>
    </React.Fragment>
  );
};

export default DebtorInfo;
